<template>
  <v-app>
    <div class="vld-parent">
      <loading :active.sync="loading" :can-cancel="false" color="blue" />
    </div>

    <AppHeader />
    <AppNavigation />
    <AppContent />
    <AppFooter />
    {{ this.loading }}
  </v-app>
</template>

<script>
import AppHeader from "@/components/AppHeader";
import AppNavigation from "@/components/AppNavigation";
import AppContent from "@/components/AppContent";
import AppFooter from "@/components/AppFooter";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import { mapGetters } from "vuex";

export default {
  name: "App",

  components: {
    AppHeader,
    AppNavigation,
    AppContent,
    AppFooter,

    Loading,
  },

  data: () => ({}),

  computed: {
    ...mapGetters({
      loading: "account/loading",
    }),
  },
};
</script>
